<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Add Vehicle Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleDetails' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
      <v-row>
        <v-col cols="12" lg="3" sm="6" >
        <span class="body-2 font-weight-medium"> Academic Year</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="academicYearID" key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium">Select Franchisee</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="franchiseeID" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Registration Number </span>
        <span class="error--text ml-1">*</span>
        <v-text-field v-model.trim="registrationNo" required class="my-0 py-1">
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Make Of the vehicle </span>
         <span class="error--text ml-1">*</span>
        <v-text-field v-model.trim="MakeOfvehicle" required class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Model Of the vehicle </span>
        <v-text-field v-model.trim="ModelOfvehicle" class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Chasis No </span>
        <v-text-field v-model.trim="ChasisNo"  class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Battery No </span>
        <v-text-field v-model.trim="batteryNo" class="my-0 py-1">
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Seating Capacity </span>
         <span class="error--text ml-1">*</span>
        <v-text-field v-model.trim="seatingCapacity" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Engine Number</span>
        <v-text-field v-model.trim="engineNumber" class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
          <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> VTS Activation</span>

        <v-autocomplete  v-model="vtsActivation" key="id" class="my-0 py-1" single-line placeholder="---Select---" readonly :items="vtsactivations" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
     <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Type</span>
         <span class="error--text ml-1">*</span>
        <v-autocomplete  v-model="vehicleType" @change="clear()" required key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="VehicleTypes" item-text="name" item-value="value">
        </v-autocomplete>
      </v-col>
       <v-col cols="12" lg="3" sm="6" v-if="this.vehicleType !=='School Owned'">
        <span class="body-2 font-weight-medium"> Monthly Rent Cost</span>

         <v-text-field v-model.trim="rentCost"  class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> Purchase Date</label>
              <custom-date-picker v-model="Purchasedate" />
            </v-col>
          <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> RC Book No.</span>
          <span class="error--text ml-1">*</span>
         <v-text-field v-model.trim="RCBookNo" required class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
     <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> RC Start Date </label>
               <span class="error--text ml-1">*</span>
              <custom-date-picker v-model="RCStartdate" required />
            </v-col>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> RC Expiry Date </label>
               <span class="error--text ml-1">*</span>
              <custom-date-picker v-model="RCExpirydate" :minToDate="this.RCStartdate"  required/>
            </v-col>
    </v-row>
</v-col>
</v-row>
<div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Upload Vehicle Details
                </label>
                <b-field class="file is-primary">
                  <b-upload @input="onFilechange()" v-model="dropFile" multiple class="file-label">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <!--<span class="has-text-danger">Allowed files:  .png, .jpg, .jpeg, .pdf </span>-->
<br/><br/> <!--<span class="has-text-danger">File's that are not supported will be removed automatically!</span>-->
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;">Create</button>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
export default {
  name: 'addVehicleDetails',
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      franchiseeID: '',
      vtsActivation: 1,
      batteryNo: '',
      MakeOfvehicle: '',
      RCBookNo: '',
      RCExpirydate: '',
      RCStartdate: '',
      ChasisNo: '',
      engineNumber: '',
      rentCost: 0,
      MakeOfthevehicle: '',
      seatingCapacity: '',
      Purchasedate: '',
      ModelOfvehicle: '',
      isReadOnly: true,
      registrationNo: '',
      franchiseeArr: [],
      academicYearID: '',
      isRequired: false,
      vehicleType: 'School Owned',
      selectedFranchisee: [],
      academicYears: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      vtsactivations: [
        { id: 1, name: 'YES' }
      ],
      VehicleTypes: [
        { id: 1, name: 'School Owned', value: 'School Owned' },
        { id: 2, name: 'Leased Vehicle', value: 'Leased Vehicle' },
        { id: 3, name: 'Vendor Owned', value: 'Vendor Owned' }
      ],
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
  },
  methods: {
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.vehicleType !== 'School Owned' && Number(this.rentCost) < 1) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter Valid Amount',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (this.RCStartdate === '') {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter RC Start date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (this.RCExpirydate === '') {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter RC Expiry date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let formData = new FormData()
        formData.append('franchiseeID', this.franchiseeID)
        formData.append('academicYearID', this.academicYearID)
        formData.append('vehicleRegistrationNumber', this.registrationNo)
        formData.append('makeOfVehicle', this.MakeOfvehicle)
        formData.append('modelOfVehicle', this.ModelOfvehicle)
        formData.append('chasisNumber', this.ChasisNo)
        formData.append('batteryNumber', this.batteryNo)
        formData.append('seatingCapacity', this.seatingCapacity)
        formData.append('vtsActivation', this.vtsActivation)
        formData.append('vehicleType', this.vehicleType)
        formData.append('vehicleEngineNumber', this.engineNumber)
        formData.append('vehiclePurchaseDate', this.Purchasedate)
        formData.append('rcBookNumber', this.RCBookNo)
        formData.append('rcStartDate', this.RCStartdate)
        formData.append('rcExpiryDate', this.RCExpirydate)
        if (this.vehicleType !== 'School Owned') {
          formData.append('monthlyRentCost', this.rentCost)
        } else {
          formData.append('monthlyRentCost', '')
        }
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('vehicleDetailsAttachements', this.dropFile[i])
        }
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleDetails' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    // onFilechange () {
    //   let r = this.dropFile.filter((a, i) => {
    //     if (this.allowedFiles.includes(a.name.split('.').pop())) {
    //     }
    //     return this.allowedFiles.includes(a.name.split('.').pop())
    //   })
    //   this.dropFile = r
    // }
    clear () {
      if (this.vehicleType !== 'School Owned') {
        this.isRequired = true
        this.rentCost = ''
      }
    }
  }
}
</script>
